import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-tab',
  templateUrl: './tab.component.html',
  styleUrls: ['./tab.component.scss'],
})
export class TabComponent implements OnInit {

  @Input('tabTitle') title: string;
  @Input('sectionId') sectionId: string;
  @Input('disabled') disabled: boolean;
  @Input() active = false;

  constructor() { }

  ngOnInit() {}


}
